import { useState, useRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  DialogActions,
  Button,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import colors from "../theme/Colors";
import ShareIcon from '@mui/icons-material/Share';
import html2canvas from 'html2canvas';
import { toast } from 'react-toastify';
import { api } from '../helpers/apiRequest';
import OrderShareDialog from './OrderShareDialog';
// import { sizes } from '../helpers/sizes';

const StyledTableCell = styled(TableCell)(() => ({
  border: '1px solid #dee2e6',
  padding: '8px',
  textAlign: 'center',
  '&.header': {
    backgroundColor: '#f8f9fa',
    fontWeight: 'bold',
    borderBottom: '2px solid #dee2e6',
  }
}));

const StyledTableRow = styled(TableRow)({
  '&:nth-of-type(odd)': {
    backgroundColor: '#ffffff',
  },
  '&:nth-of-type(even)': {
    backgroundColor: '#f8f9fa',
  },
});

const HeaderBox = styled(Box)({
  border: '1px solid #dee2e6',
  padding: '8px 16px',
  marginBottom: '16px',
  '& .MuiTypography-root': {
    marginBottom: '4px',
  }
});

const OrderDetailsDialog = ({ open, handleClose, order }) => {
  
  const [shareDialog, setShareDialog] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [customers, setCustomers] = useState([]);
  const sharePreviewRef = useRef(null);

  const fetchCustomers = async () => {
    try {
      const response = await api.get('users/users/role/customer');
      setCustomers(response.data.data || []);
    } catch (error) {
      console.error('Error fetching customers:', error);
      toast.error('Error fetching customers');
    }
  };

  const handleOpenShareDialog = async () => {
    try {
      await fetchCustomers();
      setShareDialog(true);
    } catch (error) {
      console.error('Error preparing share dialog:', error);
      toast.error('Error preparing share dialog');
    }
  };

  const handleShare = async () => {
    if (!selectedCustomer) {
      toast.error('Please select a customer');
      return;
    }

    try {
      if (!sharePreviewRef.current) {
        toast.error('Preview is not ready yet');
        return;
      }

      const canvas = await html2canvas(sharePreviewRef.current, {
        backgroundColor: '#ffffff',
        scale: 2,
        useCORS: true,
        logging: false,
        width: sharePreviewRef.current.scrollWidth,
        height: sharePreviewRef.current.scrollHeight,
        windowWidth: sharePreviewRef.current.scrollWidth,
        windowHeight: sharePreviewRef.current.scrollHeight,
      });

      const blob = await new Promise((resolve) => {
        canvas.toBlob(resolve, 'image/png');
      });

      if (!blob) {
        throw new Error('Unable to generate image blob');
      }

      // Create file from blob
      const file = new File([blob], 'order.png', { type: 'image/png' });

      const formData = new FormData();
      formData.append('image', file);
      formData.append('userId', selectedCustomer);
      formData.append('orderId', order?.orderId);
      formData.append('type', "Order");
      const response = await api.post('inventory/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.status === 200) {
        toast.success('Order shared successfully');
        setShareDialog(false);
        setSelectedCustomer('');
      } else {
        toast.error('Failed to share order');
      }
    } catch (error) {
      console.error('Error sharing order:', error);
      toast.error('Error sharing order');
    }
  };

  const getQuantityForSize = (sizes, targetSize) => {
    const sizeObj = sizes.find(s => s.size === targetSize);
    return sizeObj ? sizeObj.quantity : '';
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Typography variant="h6" align="center" sx={{
          fontWeight: 'bold',
          backgroundColor: colors.primary,
          padding: '8px',
          borderRadius: '4px'
        }}>
          ORDER FORM
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <HeaderBox>
              <Typography><strong>CUSTOMER:</strong> {order?.customer?.name || 'MOHAN'}</Typography>
              <Typography><strong>ORDER NO:</strong> {order?.orderId || '2'}</Typography>
              <Typography><strong>STATUS:</strong> {order?.status || 'PENDING'}</Typography>
            </HeaderBox>
            <HeaderBox>
              <Typography><strong>DATE:</strong> {new Date(order?.createdAt).toLocaleDateString() || 'N/A'}</Typography>
              <Typography><strong>ORDER BY:</strong> {order?.created_by?.name || 'ARSHAD'}</Typography>
              <Typography><strong>SHIPPED VIA:</strong> {order?.shipped_via || 'N/A'}</Typography>
              {
                order?.status==='SHIPPED'&&
                <Typography><strong>SHIPPED Date:</strong> {new Date(order?.shipped_date).toLocaleDateString() || 'N/A'}</Typography>

              }
              
            </HeaderBox>
          </Box>

          {/* Order Details Table */}
          <Paper sx={{ width: '100%', overflow: 'hidden', border: '1px solid #dee2e6' }}>
            <Table size="small">
              {/* <TableHead>
                <TableRow sx={{ backgroundColor: '#e9ecef' }}>
                  <StyledTableCell className="header">PARTY</StyledTableCell>
                  <StyledTableCell className="header">P-STYLE</StyledTableCell>
                  <StyledTableCell className="header">ITEM</StyledTableCell>
                  <StyledTableCell className="header">COLOR</StyledTableCell>
                 
                  <StyledTableCell className="header">XS</StyledTableCell>

                  <StyledTableCell className="header">S</StyledTableCell>
                  <StyledTableCell className="header">M</StyledTableCell>
                  <StyledTableCell className="header">L</StyledTableCell>
                  <StyledTableCell className="header">XL</StyledTableCell>
                  <StyledTableCell className="header">2XL</StyledTableCell>
                  <StyledTableCell className="header">3XL</StyledTableCell>

                  <StyledTableCell className="header">MIX</StyledTableCell>
                  <StyledTableCell className="header">TOT QTY</StyledTableCell>
                  <StyledTableCell className="header">RATE</StyledTableCell>
                  <StyledTableCell className="header">AMOUNT</StyledTableCell>
                </TableRow>
              </TableHead> */}
              <TableHead>
                <TableRow sx={{ backgroundColor: '#e9ecef' }}>
                  <StyledTableCell className="header" rowSpan={2}>PARTY</StyledTableCell>
                  <StyledTableCell className="header" rowSpan={2}>P-STYLE</StyledTableCell>
                  <StyledTableCell className="header" rowSpan={2}>ITEM</StyledTableCell>
                  <StyledTableCell className="header" rowSpan={2}>COLOR</StyledTableCell>
                  <StyledTableCell className="header" rowSpan={2}>XS</StyledTableCell>
                  <StyledTableCell className="header" colSpan={2}>Small</StyledTableCell>
                  <StyledTableCell className="header" colSpan={2}>Medium</StyledTableCell>
                  <StyledTableCell className="header" colSpan={2}>Large</StyledTableCell>
                  <StyledTableCell className="header" rowSpan={2}>XL</StyledTableCell>
                  <StyledTableCell className="header" rowSpan={2}>2XL</StyledTableCell>
                  <StyledTableCell className="header" rowSpan={2}>3XL</StyledTableCell>
                  <StyledTableCell className="header" rowSpan={2}>MIX</StyledTableCell>
                  <StyledTableCell className="header" rowSpan={2}>TOT QTY</StyledTableCell>
                  <StyledTableCell className="header" rowSpan={2}>RATE</StyledTableCell>
                  <StyledTableCell className="header" rowSpan={2}>AMOUNT</StyledTableCell>
                </TableRow>
                <TableRow sx={{ backgroundColor: '#e9ecef' }}>
                  <StyledTableCell className="header">6M</StyledTableCell>
                  <StyledTableCell className="header">2Y</StyledTableCell>
                  <StyledTableCell className="header">12M</StyledTableCell>
                  <StyledTableCell className="header">4Y</StyledTableCell>
                  <StyledTableCell className="header">12M</StyledTableCell>
                  <StyledTableCell className="header">6Y</StyledTableCell>
                </TableRow>
              </TableHead>


              <TableBody>
                {order?.items?.map((item, index) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell>{item?.stock?.party?.name || 'null'}</StyledTableCell>
                    <StyledTableCell>{item?.stock?.p_style?.name || 'null'}</StyledTableCell>
                    <StyledTableCell>{item?.stock?.item?.name || 'null'}</StyledTableCell>
                    <StyledTableCell>{item?.stock?.color || 'null'}</StyledTableCell>

                    {/* XS */}
                    <StyledTableCell>{getQuantityForSize(item?.sizes, 'XS') || 0}</StyledTableCell>

                    {/* S (single value across 2 cols) */}
                    <StyledTableCell colSpan={2}>
                      {getQuantityForSize(item?.sizes, 'S') || 0}
                    </StyledTableCell>

                    {/* M */}
                    <StyledTableCell colSpan={2}>
                      {getQuantityForSize(item?.sizes, 'M') || 0}
                    </StyledTableCell>

                    {/* L */}
                    <StyledTableCell colSpan={2}>
                      {getQuantityForSize(item?.sizes, 'L') || 0}
                    </StyledTableCell>

                    {/* Rest are single cells */}
                    <StyledTableCell>{getQuantityForSize(item?.sizes, 'XL') || 0}</StyledTableCell>
                    <StyledTableCell>{getQuantityForSize(item?.sizes, '2XL') || 0}</StyledTableCell>
                    <StyledTableCell>{getQuantityForSize(item?.sizes, '3XL') || 0}</StyledTableCell>
                    <StyledTableCell>{getQuantityForSize(item?.sizes, 'MIX') || 0}</StyledTableCell>

                    {/* Total qty */}
                    <StyledTableCell>
                      {item.sizes.reduce((sum, size) => sum + Number(size.quantity), 0)}
                    </StyledTableCell>

                    {/* Price */}
                    <StyledTableCell>{item?.price}</StyledTableCell>

                    {/* Amount */}
                    <StyledTableCell>
                      {item?.price *
                        item.sizes.reduce((sum, size) => sum + Number(size.quantity), 0)}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>

            </Table>
          </Paper>

          {/* Totals Section */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <HeaderBox sx={{ width: '200px' }}>
              {/* <Typography><strong>SUB TOTAL:</strong> {totals.amount.toFixed(2)}</Typography> */}
              <Typography><strong>SUB TOTAL:</strong> {order?.total_price.toFixed(2)}</Typography>

              <Typography><strong>DISCOUNT:</strong> {order?.discount || 0}</Typography>
              <Typography><strong>TOTAL:</strong> {(order?.total_price.toFixed(2) - (order?.discount || 0)).toFixed(2)}</Typography>
              <Typography><strong>GST %:</strong> {order?.gst || ''}</Typography>
              <Typography><strong>QST %:</strong> {order?.qst || ''}</Typography>
              <Typography><strong>G TOTAL:</strong> {(order?.final_price).toFixed(2) || 0}</Typography>
            </HeaderBox>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', px: 1 }}>
          <Button
            variant="contained"
            startIcon={<ShareIcon />}
            onClick={handleOpenShareDialog}
            sx={{
              backgroundColor: colors.primary,
              color: 'black',
              '&:hover': {
                backgroundColor: colors.primary,
                opacity: 0.9
              }
            }}
          >
            Share Order
          </Button>
          <Button variant="contained" onClick={handleClose} color="primary">
            Close
          </Button>
        </Box>
      </DialogActions>

      <OrderShareDialog
        open={shareDialog}
        handleClose={() => {
          setShareDialog(false);
          setSelectedCustomer('');
        }}
        selectedCustomer={selectedCustomer}
        setSelectedCustomer={setSelectedCustomer}
        customers={customers}
        order={order}
        previewRef={sharePreviewRef}
        handleShare={handleShare}
      />
    </Dialog>
  );
};

export default OrderDetailsDialog;
